import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FAFFEE] to-[#EDEDFE] relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#0C6951] font-semibold uppercase tracking-wider">
              <Link to="/" className="hover:text-[#004534]">Home</Link>
              <ChevronRight className="w-4 h-4" />
              Terms & Conditions
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mt-4">
              Terms & Conditions
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p className="text-[#807979] leading-relaxed mb-8">
              Last updated: January 2026
            </p>
            
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">1. Acceptance of Terms</h2>
                <p className="text-[#807979] leading-relaxed">
                  By accessing and using MLDC Agro's services, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">2. Services</h2>
                <p className="text-[#807979] leading-relaxed">
                  MLDC Agro provides agricultural produce supply services, including procurement, quality assurance, storage, and logistics. Our services are subject to availability and may vary by location.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">3. User Responsibilities</h2>
                <p className="text-[#807979] leading-relaxed">
                  You agree to provide accurate information when using our services, comply with all applicable laws and regulations, and not misuse our platform or services in any way.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">4. Pricing and Payment</h2>
                <p className="text-[#807979] leading-relaxed">
                  Prices for our products and services are subject to change. Payment terms will be agreed upon in individual contracts or purchase agreements.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">5. Limitation of Liability</h2>
                <p className="text-[#807979] leading-relaxed">
                  MLDC Agro shall not be liable for any indirect, incidental, special, or consequential damages arising from the use of our services.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">6. Governing Law</h2>
                <p className="text-[#807979] leading-relaxed">
                  These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Uttar Pradesh.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">7. Contact</h2>
                <p className="text-[#807979] leading-relaxed">
                  For any questions regarding these terms, please contact us at support@mldcagro.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
